function hasArrayIntersect(firstArray, secondArray) {
   //https://gist.github.com/jamiehs/3364281
  var intersects = $.map(firstArray, function (item) {
      var inArrayInt = $.inArray(parseInt(item), secondArray);
      var inArrayString = $.inArray(item.toString(), secondArray);
      if (inArrayInt < 0 || inArrayString < 0) {
          return null;
      } else if (inArrayInt) {
          return inArrayInt;
      } else {
          return inArrayString;
      }
  });

  return (intersects && intersects.length);
}

$(document).ready(function () {
    //livescrolling trigger
    var liveScrollingTrigger = null;
    var liveScrollElement = document.getElementById("liveScroll");
    if (liveScrollElement) {
        liveScrollingTrigger = liveScrollElement.getAttribute('value');
    }

    var names = document.querySelector('.ticker-list span');
    //Pusher listeners
    var advocates = p2apusherapp.pusher.subscribe('advocates');
    var legislator_connects = p2apusherapp.pusher.subscribe('legislator_connects');
    window.advids = [];
    window.shownadvids = [];
    window.connectids = [];

    function calculateLatLonForIncomingData(data)
    {
        var lat = null;
        var lon = null;

        if (window.requireLatLon) {
            lat = data['lat'];
            lon = data['lon'];
        } else if (data['data'] && data['data']['zip5']) {
            var latLon = window.zipsWithLatLon[data['data']['zip5']];
            if (latLon) {
                lat = latLon.lat;
                lon = latLon.lon;
            }
        }

        return {
            lat: lat,
            lon: lon
        };
    };

    advocates.bind('create', function(data) {
        var advLatLon = calculateLatLonForIncomingData(data);

        if((
                jQuery.inArray(window.campaignid.toString(), data['campaigns']) >= 0
                ||
                jQuery.inArray(parseInt(window.campaignid), data['campaigns']) >= 0
                ||
                hasArrayIntersect(window.campaignids, data['campaigns'] )
            )
            && (jQuery.inArray(data['id'].toString(),window.advids) === -1)
            && advLatLon.lat && advLatLon.lon
        ) {

            window.advids.push(data['id'].toString());

            //add advocate
            if (liveScrollingTrigger === '1' && data['firstname']) {
                scrollingAddAdvocateToPage(data, advLatLon.lat, advLatLon.lon);
            } else {
                addAdvocateToPage(data, advLatLon.lat, advLatLon.lon);
            }
        }
    });

    advocates.bind('update', function(data) {
        var advLatLon = calculateLatLonForIncomingData(data);

        if((
                jQuery.inArray(window.campaignid.toString(), data['campaigns']) >= 0
                ||
                jQuery.inArray(parseInt(window.campaignid), data['campaigns']) >= 0
                ||
                jQuery.inArray(window.campaignid.toString(), data['newlyjoinedcampaigns']) >= 0
                ||
                jQuery.inArray(parseInt(window.campaignid), data['newlyjoinedcampaigns']) >= 0
                ||
                hasArrayIntersect(window.campaignids, data['campaigns'] )
                ||
                hasArrayIntersect(window.campaignids, data['newlyjoinedcampaigns'] )
            )
            && (jQuery.inArray(data['id'].toString(), window.advids) === -1)
            && advLatLon.lat && advLatLon.lon
        ) {
            window.advids.push(data['id'].toString());

            //add advocate
            if (liveScrollingTrigger==='1' && data['firstname']) {
                scrollingAddAdvocateToPage(data, advLatLon.lat, advLatLon.lon);
            } else {
                addAdvocateToPage(data, advLatLon.lat, advLatLon.lon);
            }
        }
    });

    legislator_connects.bind('create', function (data) {
        if ((jQuery.inArray(window.campaignid.toString(), data['campaigns']) >= 0 || jQuery.inArray(parseInt(window.campaignid), data['campaigns']) >= 0 || hasArrayIntersect(window.campaignids, data['campaigns'])) && jQuery.inArray(data['data']['connid'].toString(), window.connectids) == -1) {
            window.connectids.push(data['data']['connid'].toString());
            increaseLegConnection();
        }
    });
});

function Commas(yourNumber) {
    //Seperates the components of the number
    var n = yourNumber.toString().split(".");
    //Comma-fies the first part
    n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //Combines the two sections
    return n.join(".");
}

var maptransitionspeed = 400;

function addAdvocateToPage(data, advLat, advLon) {
    $('body').queue('increasenumberqueue', function(next) {
        if (jQuery.inArray(data['id'].toString(),window.shownadvids) === -1) {
            window.shownadvids.push(data['id'].toString());
            var adv = $('#advocates').html().replace(/,/g, '');
            adv = parseInt(adv) + 1;
            adv = Commas(adv);

            $('#advocates').html(adv);

            newPin(advLat, advLon);

            if (data['firstname']) {
                var advnum = 0;
                $('.ticker-list .name').each(function (index, value) {
                    advnum++;
                    if (advnum > window.maxadvtoshow) {
                        //Hide it slowly, then remove it
                        $('.ticker-list .name:last').hide(maptransitionspeed, function () {
                            $(this).remove();
                            var namelast = $('.ticker-list .name:last');
                            namelast.text(namelast.text().slice(0, -1));
                        });
                    }
                });

                $('.ticker-list').prepend('<span class="name justaddedadv" style="display: none;">' + data['firstname'] + ',</span>');

                $('.justaddedadv').show(maptransitionspeed, function () {
                    $(this).removeClass('justaddedadv');
                });
            }
        }

        next();
    });

    if ($('body').queue('increasenumberqueue').length == 1) {
        $('body').dequeue('increasenumberqueue');
    }
}

//add advocate method if scrolling is turned on
function scrollingAddAdvocateToPage(data, advLat, advLon) {
    //helper variable to help keep track of advocate count
    var advCount = 0;
    var advCountElement = document.getElementById("advCount");
    if (advCountElement) {
      advCount = advCountElement.getAttribute('value');
    }
    //makes it an int
    advCount = parseInt(advCount, 10);
    //increases the counter
    advCount = advCount + 1;
    //resets the attribute to its original plus one
    document.getElementById("advCount").setAttribute('value', advCount);
    //turns on liveScrolling if advocate count is 20 after increasing counter one
    if (advCount === 20) {
        liveScrolling();
    }
    $('body').queue('increasenumberqueue', function (next) {
        if (jQuery.inArray(data['id'].toString(), window.shownadvids) === -1) {
            window.shownadvids.push(data['id'].toString());
            var adv = $('#advocates').html().replace(/,/g, '');
            adv = Commas(parseInt(adv) + 1);
            $('#advocates').html(adv);
            newPin(advLat, advLon);
            var advnum = 0;
            $('.ticker-list .name').each(function (index, value) {
                advnum++;
            });
            //grabs element that has the first names
            var temp = document.getElementsByClassName("scroll");
            //appends to nameList
            //if this advocate is first one in the list, don't give them a comma
            if (advCount === 1) {
                temp[0].append(data['firstname']);
            } else {
                if (advCount < 20) {
                    $(temp[0]).text($(temp[0]).text() + ', ' + data['firstname']);
                } else {
                    $(temp[0]).text($(temp[0]).text() + ', ' + data['firstname']);
                    $(temp[1]).text($(temp[1]).text() + ', ' + data['firstname']);
                }
            }
        }
        next();
    });
    if ($('body').queue('increasenumberqueue').length == 1) {
        $('body').dequeue('increasenumberqueue');
    }
}

function increaseLegConnection() {
    $('body').queue('increasenumberqueue', function (next) {

        var conn = $('#connections').html().replace(/,/g, '');
        conn = parseInt(conn) + 1;
        conn = Commas(conn);
        $('#connections').html(conn);

        next();
    });

    if ($('body').queue('increasenumberqueue').length == 1) {
        $('body').dequeue('increasenumberqueue');
    }
}

//when run, starts name scroll
function liveScrolling() {
    var r = 50;
    var adjust = 4;

    var obj = $('.name-list span');
    var d = obj.width();
    var t = d / r;
    if (document.getElementsByClassName("scroll").length === 1) {
        obj.clone().appendTo(obj.parent());
    }

    TweenMax.to(obj.parent(), t, {
        x: "-" + (d + adjust),
        ease: Linear.easeNone,
        repeat: -1
    });
}